module.exports = __webpack_public_path__ + "img/addon-large-meetings.120e778f.png";